import { render, staticRenderFns } from "./UserPushCompanyCheck.vue?vue&type=template&id=150c21bc&"
import script from "./UserPushCompanyCheck.vue?vue&type=script&lang=js&"
export * from "./UserPushCompanyCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports